import { ProfilePicture } from '@/components/profile-picture/profile-picture'
import { WalletProfileContainer, UsernameText, ButtonWrapper } from './style-component'
import { WalletProfileBannerProps } from './wallet-profile-banner-types'
import { useNavigate } from 'react-router-dom'
import { SettingOutlined } from '@ant-design/icons'
import CustomButton from '@/components/custom-button/custom-button'
import { useTheme } from 'styled-components'
import { formatAddress } from '@/utils/string/format'

export const WalletProfileBanner: React.FC<WalletProfileBannerProps> = ({ 
    profileImage,
    username,
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const handleNavigateToConfig = () => {
        navigate('/wallet/configuration');
    };

    const handleEditProfile = () => {
        navigate('/register');
    };
    
    return (
        <WalletProfileContainer>
            <ProfilePicture 
                initialImage={profileImage}
                onClick={handleEditProfile}
                editable={false}
            />
            <UsernameText>{formatAddress(username)}</UsernameText>
            <ButtonWrapper>
                <CustomButton 
                    onClick={handleNavigateToConfig} 
                    variant="text"
                    style={{ 
                        color: theme?.colors?.text?.paragraphs,
                    }}
                >
                    <SettingOutlined style={{ fontSize: '20px' }} />
                    Configuración
                </CustomButton>
            </ButtonWrapper>
        </WalletProfileContainer>
    )
}
